// @mui
import { Box, Container, Stack, Typography, Divider, TextField } from '@mui/material';
// components
import Iconify from 'src/components/iconify/iconify';
import { useSettingsContext } from 'src/components/settings';

import { useSelector } from 'src/store';
import { toCurrency } from 'src/utils/to-currency';

export { default as TransactionView } from "./transactions";

// ----------------------------------------------------------------------
type ViewProps = {
  setEditPage: (value: string) => void;
};

const CashierView = ({ setEditPage }: ViewProps) => {
  const settings = useSettingsContext();
  const { user } = useSelector((state) => state.auth);

  const itemList = [
    {
      title: "Deposit",
      text: "Deposit to your account",
      icon: "mdi:plus-box-outline",
      value: "profile",
      component: <Box />
    },
    {
      title: "Withdrawal",
      text: "Withdraw from your account",
      icon: "mdi:minus-box-outline",
      value: "verification",
      component: <Box />
    },
    {
      title: "Transactions",
      text: "See your transactions and gaming activity",
      icon: "entypo:back-in-time",
      value: "transactions",
      component: <Box />
    }
  ];

  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
      <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" gap={1} mt={2}>
        <TextField
          name="balance"
          label="Balance"
          value={toCurrency(user.balance || 0, user.currency)}
          disabled
        />

        <TextField
          name="bonus"
          label="Bonus"
          value={toCurrency((user?.bonus || 0) + (user?.matchBonus || 0), user.currency)}
          disabled
        />

        <TextField
          name="wagerAmount"
          label="Wager Requirement"
          value={toCurrency(user.wagerAmount || 0, user.currency)}
          disabled
        />
      </Stack>

      <Stack
        direction="column"
        gap={0.5}
        sx={{
          p: 1,
          mt: 3,
          mb: 1,
          width: 1,
          borderRadius: 2,
          backgroundColor: '#fff',
          boxShadow: '0 .25rem .5rem rgba(0,0,0,.06),0 .125rem 0 rgba(0,0,0,.05)',
        }}
      >
        {itemList.map((item, index) => (
          <Box key={index}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                cursor: 'pointer',
                borderRadius: 1,
                '&:hover': {
                  color: '#ee2b25',
                  backgroundColor: '#f7002505',
                },
              }}
              onClick={() => {
                setEditPage(item.value);
              }}
            >
              <Box p={2}>
                <Iconify icon={item.icon} width={24} m={0.5} />
              </Box>
              <Stack direction="column" gap={1} flexGrow={1}>
                <Typography variant="body1">{item.title}</Typography>
                <Typography variant="body2">{item.text}</Typography>
              </Stack>
              <Iconify icon="grommet-icons:form-next" sx={{ m: 2, flexShrink: 0 }} />
            </Stack>
            <Box>
              <Divider sx={{ ml: 8 }} />
            </Box>
          </Box>
        ))}
      </Stack>
    </Container>
  );
}

export default CashierView;